import { combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { configureStore } from 'js-utils/redux';

import resourceCacheReducer from './reducer';
import resourceCacheMiddleware from './middleware';
import { updateResource, getResource } from './api';

/**
 * This tool offers an easy way to test if the resource cache is updated
 * correctly in the store (such as after updateResource calls).
 * It returns access to the store's dispatch and getState methods
 * along with a method to get the resource cache.
 *
 * @param {string} stateResourceCacheKey
 * @param {object} reducers
 * @returns {object} containing store's dispatch, getState, along with getResource method
 *
 */
export const getMockResourceCacheTools = (
    stateResourceCacheKey,
    reducers = {},
) => {
    if (!stateResourceCacheKey) {
        throw new Error('State resource cache key required');
    }

    const store = configureStore({
        reducer: combineReducers({
            ...reducers,
            [stateResourceCacheKey]: resourceCacheReducer,
        }),
        initialState: {},
        middleware: [thunk, resourceCacheMiddleware],
    });

    return {
        dispatch: store.dispatch,

        getState: store.getState,

        setResource: (cacheKey, data) =>
            updateResource(
                store.dispatch,
                stateResourceCacheKey,
                cacheKey,
                data,
            ),

        getResource: (cacheKey) =>
            getResource(store.getState()[stateResourceCacheKey], cacheKey),
    };
};
